import {createSvgIcon} from '../create-svg-icon';

export const GroupWorkIcon = createSvgIcon(
  [<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" key="0" />,<circle cx="8" cy="14" r="2" key="1" />,<circle cx="12" cy="8" r="2" key="2" />,<circle cx="16" cy="14" r="2" key="3" />,]
, 'GroupWorkOutlined');
